import React, { useEffect, useRef, useState } from "react";
import CoreInput from "../../core/inputs/CoreInput";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import {
  API_METHOD_POST,
  googleLoginEnabled,
  newUserEnabled,
} from "../../config/constants";
import {
  CHECK_USER_EXIST_ERROR,
  CHECK_USER_EXIST_LOADING,
  CHECK_USER_EXIST_SUCCESS,
  GOOGLE_LOGIN_ERROR,
  GOOGLE_LOGIN_LOADING,
  GOOGLE_LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  SET_AUTH_REDUCER,
  SIGNUP_ERROR,
  SIGNUP_SUCCESS,
} from "../../store/types/authTypes";
import { setAuthReducer } from "../../store/actions/authActions";
import { Box } from "@mui/material";
import AuthContainer from "./AuthContainer";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { GoogleLogin } from "@react-oauth/google";
import { theme } from "../../config/theme";
import CoreH4 from "../../core/dataDisplay/CoreH4";
import { Formik } from "formik";
import { emailOrPhoneSchema, loginSchema } from "../../formSchemas/authSchemas";
import CoreCaptcha from "../../core/inputs/CoreCaptcha";
import CorePassword from "../../core/inputs/CorePassword";
import NewUser from "../admin/UserOperations/NewUser";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import CoreTextButton from "../../core/inputs/CoreTextButton";
import { useNavigate } from "react-router";
import { setNextUrl } from "../../store/actions/routeActions";

export default function SignUp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const captchaRef = useRef();
  const [captchaToken, setCaptchaToken] = useState("");
  const authError = useSelector((state) => state?.auth?.authError);

  const appSettings = useSelector((state) => state?.common?.appSettings);
  const verificationRequired = useSelector(
    (state) => state?.auth?.verificationRequired,
  );

  const googleLogin = appSettings?.find(
    (set) => set.name === googleLoginEnabled,
  )
    ? appSettings?.find((set) => set.name === googleLoginEnabled)?.value
        ?.enabled
    : true;

  const newUser = appSettings?.find((set) => set.name === newUserEnabled)
    ? appSettings?.find((set) => set.name === newUserEnabled)?.value?.enabled
    : true;

  const onSubmit = (values, actions) => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/signup",
        values,
        {},
        null,
        SIGNUP_SUCCESS,
        SIGNUP_ERROR,
        false,
        false,
      ),
    );
  };

  const onGoogleLoginSuccess = (data) => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/login/google",
        {
          credential: data?.credential,
        },
        {},
        GOOGLE_LOGIN_LOADING,
        GOOGLE_LOGIN_SUCCESS,
        GOOGLE_LOGIN_ERROR,
        false,
        false,
      ),
    );
  };

  const onBack = () => {
    navigate("/login");
    dispatch(setNextUrl("/login"));
  };

  useEffect(() => {
    if (verificationRequired) {
      navigate("/verify/account");
      dispatch(setNextUrl("/verify/account"));
    }
  }, [verificationRequired]);

  useEffect(() => {
    if (authError) {
      captchaRef?.current?.reset();
    }
  }, [authError]);

  return (
    <AuthContainer showHeading={true}>
      <CoreH4
        style={{
          fontStyle: "italics",
          color: theme.palette.primary.main,
          alignSelf: "baseline",
        }}
      >
        Sign Up
      </CoreH4>
      <form onSubmit={onSubmit} style={{ width: "100%" }}>
        {googleLogin ? (
          <>
            <Box style={{ marginTop: 16 }}>
              <GoogleLogin
                style={{ width: "100%" }}
                onSuccess={onGoogleLoginSuccess}
                onError={() => {
                  console.log("Login Failed");
                }}
                useOneTap
              />
            </Box>
            <p
              style={{
                textAlign: "center",
                marginTop: 16,
              }}
            >
              <span
                style={{
                  backgroundColor: theme.palette.background.paper,
                  paddingLeft: 16,
                  paddingRight: 16,
                }}
              >
                or
              </span>
            </p>
            <div
              style={{
                height: 2,
                backgroundColor: theme.palette.grey[300],
                marginTop: -24,
                marginBottom: 24,
              }}
            ></div>
          </>
        ) : (
          <Box style={{ padding: 8 }} />
        )}
        <NewUser signup={true} handleSubmit={onSubmit} />
        <Box style={{ display: "flex", justifyContent: "center" }}>
          <CoreTextButton
            onClick={() => {
              onBack();
              navigate(-1);
            }}
          >
            Cancel
          </CoreTextButton>
        </Box>
        <Box style={{ marginTop: 8 }}>
          <CoreTypographyBody1 component="span">
            By continuing you agree to our{" "}
          </CoreTypographyBody1>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.vixplor.com/privacy-policy"
          >
            <CoreTypographyBody1 component="span">
              Privacy Policy
            </CoreTypographyBody1>
          </a>
          <CoreTypographyBody1 component="span"> & </CoreTypographyBody1>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.vixplor.com/terms-conditions"
          >
            <CoreTypographyBody1 component="span">Terms</CoreTypographyBody1>
          </a>
        </Box>
      </form>
    </AuthContainer>
  );
}
